import React from "react";
import { Bac, Bam, Banrural, Interbanco, GT } from "./iconos_bancos";
import { ComboCuentas } from "./ComboCuentas";

const CirculosBancos = ({
  filter,
  setFilter,
  handleCuenta,
  setCuenta,
  handleSede,
  banco,
  bancos,
  cuentas,
}) => {
  const sedes = (sede) => {
    const bancosImg = {
      1: GT,
      2: Interbanco,
      5: Bam,
      6: Banrural,
      19: Bac,
    };
    return bancosImg[sede];
  };

  return (
    <div className="flex /m-auto /xl:flex-row flex-row justify-center elementFadeIn1s ">
      <div
        className={
          "w-full /lg:w-1/2 flex flex-row justify-start my-2 mx-2"
        }
      >
        {bancos.map((element, index) => (
          <>
            <div
              key={index}
              className={`flex flex-row ${banco === element["IdBanco"] ? " border-b-2 rounded-full border-secundario ease transition transform duration-500" : "" }`}
            >
              <div
                className={
                  banco === element["IdBanco"]
                    ? "flex mx-2 w-20 h-20 mb-2 "
                    : "flex mx-2 w-20 h-20 rounded-full hover:shadow-md hover:shadow-white ease transition transform duration-150"
                }
                key={element["IdBanco"]}
                onClick={() => handleSede(element["IdBanco"], element.Nombre)}
                // onMouseEnter={() => setSedeNombre(element.Nombre)}
              >
                <img
                  src={sedes(element.IdBanco)}
                  alt=""
                  className=" rounded-full h-full elementFadeIn"
                />
              </div>
            </div>
          </>
        ))}
      </div>
      {/* 
      <div
        className={"flex /lg:w-1/2 w-full flex-row justify-end my-auto h-full"}
      >
        {banco &&
        <div className="/flex flex-col my-auto hidden">
          
          <ComboCuentas
            data={cuentas}
            filter={filter}
            setCuenta={setCuenta}
            ></ComboCuentas>
          
          <h1 className="text-white">Cuentas</h1>
          <select className={"rounded-md"} onChange={(e) => handleCuenta(e)}>
            <option value="">--- Seleccione una cuenta ---</option>
            {cuentas.map((element, index) => (
              <option key={element.IdCuenta} value={element.IdCuenta}>
                {element.Cuenta}
              </option>))}
          </select>
        </div>
          } 
      </div>
          */}
    </div>
  );
};

export default CirculosBancos;
